// extracted by mini-css-extract-plugin
export default {"leftFilter":"LeftFilter_leftFilter__V94XC"};